import React, { useContext, useEffect, useState, useMemo } from 'react';
import teacherImg from '../../assets/icons/teacher.png';
import axios from '../../Utils/Axios.config';
import { useQuery } from 'react-query';

const AllRewordStudents = () => {
  const { data, isLoading, refetch, error } = useQuery('reword', () =>
    axios.get('/reword').then((res) => res.data)
  );

  // Group data by year and sort years in descending order
  const groupedData = useMemo(() => {
    if (!data) return [];

    const grouped = data.reduce((acc, item) => {
      const year = item.year;
      if (!acc[year]) {
        acc[year] = [];
      }
      acc[year].push(item);
      return acc;
    }, {});

    // Sort years in descending order and return entries array
    return Object.entries(grouped).sort(
      ([yearA], [yearB]) => Number(yearB) - Number(yearA)
    );
  }, [data]);

  return (
    <div>
      <input type="checkbox" id="Student-reword" className="modal-toggle" />
      <div className="modal h-screen modal-bottom sm:modal-middle">
        <div className="modal-box bg-blue-100 h-auto w-full sm:!w-11/12 !max-w-6xl px-3 pt-2 pb-4">
          <label
            htmlFor="Student-reword"
            className="btn z-50 btn-sm btn-circle absolute right-2 top-2"
          >
            ✕
          </label>

          <p className="my-5 text-center font-bold text-[20px] sm:text-xl font-all">
            বিগত বছরে এসএসসি পরীক্ষায় গোল্ডেন A+ ও জিপিএ G.P.A 5.00 প্রাপ্ত
            শিক্ষার্থী
          </p>

          {/* Year wise grouped data */}
          {groupedData.map(([year, students]) => (
            <div key={year} className="mb-8">
              {/* Year Header */}
              <h2 className="text-lg sm:text-xl font-bold text-primary mb-4 text-center">
                {year} গোল্ডেন A+ ও জিপিএ G.P.A 5.00 প্রাপ্ত শিক্ষার্থী
              </h2>

              {/* Students Grid */}
              <div className="reword-student-grid gap-3">
                {students.map((i, index) => (
                  <div
                    key={i?._id || index}
                    className="overflow-hidden max-w-[220px] pb-3 h-[200px] sm:h-[240px] border-[#e9ecef] bg-[#f8fafc] relative rounded-md"
                  >
                    {!i?.imgUrl && (
                      <img
                        src="https://tse4.mm.bing.net/th/id/OIP.NbebvGsxFEbg4RH8dyrfSwHaIi?r=0&rs=1&pid=ImgDetMain&o=7&rm=3"
                        className="w-full hover:scale-[1.1] duration-500 h-full"
                        alt=""
                      />
                    )}
                    {i?.imgUrl && (
                      <img
                        src={i?.imgUrl}
                        className="w-full hover:scale-[1.1] duration-500 h-full"
                        alt=""
                      />
                    )}

                    <div className="w-full px-2 h-full flex items-end text-white shadow-GPA-5 absolute bottom-0 left-0">
                      <div className="text-center w-full mb-1">
                        <h3 className="text-white font-all text-[10px] sm:text-[12px]">
                          {i?.name}
                        </h3>
                        <h6 className="text-white font-normal text-[8px] sm:text-[10px]">
                          {i?.gpa}
                        </h6>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AllRewordStudents;
